<template>
  <div :id="`${source}_deal_analytics`" class="flex flex-col gap-2 pb-3">
    <AnalyticsFilterComponent :allowed-filters="dealsAllowedFilters" />

    <DealAnalyticsGrid :primary-currency-symbol="primaryCurrencySymbol" />
    <DealRevenueGraph :primary-currency-symbol="primaryCurrencySymbol" />
    <DealPipelineGraph />
    <DealConversionGraph
      title="Deal conversion by percentage (Number of deals)"
      :type="dealConversionTypes.COUNT"
    />
    <DealConversionGraph
      title="Deal conversion by percentage (Amount)"
      :type="dealConversionTypes.AMOUNT"
    />
  </div>
</template>

<script setup>
import { computed, onMounted, ref } from "vue";
import {
  dealConversionTypes,
  dealsAllowedFilters,
} from "@/src/constants/analyticConstants.js";
import DealRevenueGraph from "@/src/views/analytics/v2/deal_analytics/DealRevenueGraph.vue";
import AnalyticsFilterComponent from "@/src/views/analytics/v2/AnalyticsFilterComponent.vue";
import DealPipelineGraph from "@/src/views/analytics/v2/deal_analytics/DealPipelineGraph.vue";
import DealAnalyticsGrid from "@/src/views/analytics/v2/deal_analytics/DealAnalyticsGrid.vue";
import DealConversionGraph from "@/src/views/analytics/v2/deal_analytics/DealConversionGraph.vue";
import DashboardService from "@/src/api/DashboardService.js";

const props = defineProps({
  source: { type: String, required: true },
});

const workspaceCurrencies = ref([]);

const primaryCurrencySymbol = computed(() => {
  if (workspaceCurrencies.value.length > 0) {
    const primaryCurrency = workspaceCurrencies.value.find(
      (curr) => curr.is_primary,
    );
    return primaryCurrency?.currency_symbol || "";
  }
  return "";
});

const fetchWorkspaceCurrencies = async () => {
  try {
    const response = await DashboardService.getWorkspaceCurrencies();
    if (response?.success && response?.currencies?.length > 0) {
      workspaceCurrencies.value = response.currencies;
    }
  } catch (error) {
    console.error("Error fetching workspace currencies:", error);
  }
};

onMounted(() => {
  fetchWorkspaceCurrencies();
});
</script>
